import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import ChamDeCuongForm from './ChamDeCuongForm';

const ChamDeCuongModal = ({ dataEdit, setViewMode, isView = false, isUserView = false }) => {
    // Mặc định là view mode (nếu isView hoặc isUserView = true thì chắc chắn view)
    const [isEditMode, setIsEditMode] = useState(false);

    if (!dataEdit) return null;

    return (
        <Modal show={true} onHide={() => setViewMode('list')} size="lg" backdrop="static">
            <Modal.Header closeButton className="bg-primary text-white">
                <Modal.Title>{isView || isUserView || !isEditMode ? 'Kết quả chấm đề cương' : 'Chấm đề cương'}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-0 custom-modal-body" style={{ maxHeight: 'calc(100vh - 150px)', overflowY: 'auto', overflowX: 'hidden' }}>
                <div className="p-3">
                    <ChamDeCuongForm 
                        hocPhanTienSiId={dataEdit.id} 
                        readOnly={!isEditMode || isView || isUserView} 
                        isUserView={isUserView} 
                        onDataLoaded={(hasData) => {
                            // Nếu chưa có dữ liệu và không phải đang ở chế độ xem cố định, tự động bật mode sửa
                            if (!hasData && !isView && !isUserView) {
                                setIsEditMode(true);
                            }
                        }}
                        onSaveSuccess={() => setIsEditMode(false)}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                {!isView && !isUserView && !isEditMode && (
                    <Button variant="warning" onClick={() => setIsEditMode(true)}>
                        <i className="fas fa-edit mr-1"></i> Cập nhật
                    </Button>
                )}
                <Button variant="secondary" onClick={() => setViewMode('list')}>
                    Đóng
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ChamDeCuongModal;
